import { EisenzeitPickel, Kratze, Kuebel, Leuchtspanbuendel } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesNhm({ currentMuseumId }) {
  const { eisenzeitPickel } = EisenzeitPickel();
  const { kratze } = Kratze();
  const { kuebel } = Kuebel();
  const { leuchtspanbuendel } = Leuchtspanbuendel();

  const artefactArray = [eisenzeitPickel, leuchtspanbuendel, kuebel, kratze];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
